<template>
  <div class="page-main">
    <h2>WS测试</h2>
    <div class="spaceLeft">
      <a-input v-model="wsType" style="width:200px"></a-input>
      <a-input v-model="wsId" style="width:200px"></a-input>
      <a-button @click="wsInit()">连接</a-button>
      <a-button @click="wsOut()">断开</a-button>
    </div>
    <div>
      {{wsReceiveMsg}}
    </div>
    
  </div>
</template>

<script>
import UtilWs from "@/common/ws.js"
export default {
  components: {},
  data() {
    return {
        wsObj:{},
        wsType:"CLIENT",
        wsId:"123",
        wsReceiveMsg:""
    };
  },
  methods: {
    wsInit(){
      this.wsObj = new UtilWs.UtilWs();			
      this.wsObj.config("ws://localhost:8181",'EMP','123');
      this.wsObj.configCallBack(this.onStatus,this.onMessage);
      this.wsObj.open();
    },
    onStatus(statObj){
      var self = this;
      this.connInfo = statObj.info+"(" + statObj.code+")";
      this.wsReceiveMsg = this.wsReceiveMsg + "\r\n" + this.connInfo;
      if(statObj.code == 2){
        //连接成功
        console.log("连接成功")
      }
      if(statObj.code == -1 || statObj.code == -5){
        if(!this.error){
          console.log("连接断开")
        }
        this.error = 1;
      }
      console.log(this.wsReceiveMsg)
    },
    onMessage(msgJson){
      this.handleCallBack(msgJson);
      var msg = JSON.stringify(msgJson);
      this.wsReceiveMsg = this.wsReceiveMsg + "\r\n" + msg;
      console.log(this.wsReceiveMsg)
    },
    handleCallBack(msgJson){
      
    },
    wsOut(){
        this.wsObj.close();
    },
    
  },
  created() {},
  mounted() {
    
  },
  destroyed() {},
  activated() {},
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/pages/test/test.vue